module.exports = __webpack_public_path__ + "img/CS-Lite-Plus_Overview.1d58e0d0.jpg";